import { Config } from './config.type'
const config: Config  = {
    "build": {
        "host": "https://graphql0.canvasflow.io",
        "subdirectory": "/",
        "website": "",
        "assetDirectory": "/",
        "title": "Morningstar Magazine",
        "description": "Stay ahead in the market with Morningstar Magazine. Get expert insights, stock analysis, and investing trends—all in one subscription.",
        "shortTitle": "Morningstar",
        "appKey": "6c0edeab-ff92-4506-9d2c-76fcdf673444",
        "language": "en",
        "languages": [
            "en"
        ],
        "about": "© Copyright 2025 Morningstar, Inc. All rights reserved. <br/><a style=\"color: #ff2d01; display: block; padding-top: 10px;\" target=\"_blank\" href=\"https://www.morningstar.com/company/privacy-policy\">Privacy Policy</a><a style=\"padding-top: 10px; display: block; color: #ff2d01;\" target=\"_blank\" href=\"https://www.morningstar.com/company/privacy-policy/california#resident-rights\">California Residents Rights</a>",
        "buildNumber": 1787020843,
        "buildDate": "2026-08-18T02:40:43.303Z",
        "version": "2.11.1"
    },
    "app": {
        "contentProtection": false,
        "admin": true,
        "favorite": false,
        "auth": {
            "enabled": false,
            "type": "login",
            "host": ""
        },
        "hideNavbarOnScroll": false,
        "installationOption": {
            "enabled": false
        },
        "password": {
            "enabled": false,
            "value": ""
        },
        "template": {
            "type": "morningstar"
        },
        "legal": {
            "tou": {
                "url": "",
                "label": "Terms of Use"
            },
            "privacy": {
                "url": "",
                "label": "Privacy Policy"
            },
            "cookie": {
                "url": "",
                "label": "Cookie Policy"
            }
        },
        "cache": {
            "ttl": {
                "getAllIssues": 60,
                "previewIssue": 60,
                "getIssue": 60,
                "getFeatureArticles": 60,
                "styles": 60
            }
        },
        "menu": {
            "links": [
                {
                    "title": "Privacy Policy",
                    "icon": "",
                    "url": "https://www.morningstar.com/company/privacy-policy"
                },
                {
                    "title": "California Residents Rights",
                    "icon": "",
                    "url": "https://www.morningstar.com/company/privacy-policy/california#resident-rights"
                }
            ]
        }
    },
    "issue": {
        "contentType": "responsive-replica",
        "lastLocation": {
            "enabled": false
        }
    },
    "analytics": {
        "tealium": {
            "ChannelID": "",
            "pageType": "",
            "pageDetail": "",
            "pageTemplate": "",
            "projectType": "",
            "url": ""
        },
        "google": {
            "trackerID": "",
            "sampleRate": 1
        },
        "ga4": {
            "trackerID": "",
            "sampleRate": 1
        },
        "gtm": {
            "trackerID": ""
        },
        "googleOptimize": {
            "trackerID": ""
        },
        "onetrust": {
            "id": ""
        },
        "caymland": {
            "domain": ""
        },
        "ackee": {
            "domainId": "",
            "server": ""
        },
        "netstats": {
            "trackerID": ""
        },
        "hotjar": {
            "trackerID": ""
        },
        "hubspot": {
            "trackerID": ""
        },
        "ShareThis": {
            "trackerID": ""
        },
        "cookiefirst": {
            "key": ""
        },
        "cookiehub": {
            "trackerID": ""
        },
        "plausible": {
            "domain": ""
        },
        "matomo": {
            "domain": ""
        }
    }
};
export default config;